import { useTranslation } from 'react-i18next';

/** Small lock + "Premium feature" label used next to gated controls. Never a modal. */
export default function PremiumLock({ className = '' }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <span className={`inline-flex items-center gap-1 text-xs text-neutral-500 ${className}`}>
      <span aria-hidden="true">🔒</span>
      {t('premium.feature')}
    </span>
  );
}
